import React, { FunctionComponent } from 'react'
import DocumentsTable from '../components/DocumentsTable'

export const ManageDocuments: FunctionComponent = () => (
  <DocumentsTable className="my-4 offset-xl-1 col-xl-10" style={{ flex: 1 }} />
)
